import React from "react";

import icon_Main from "../../../assets/svgs/MG/Vehiculo.svg";
import icon_Color from "../../../assets/svgs/MG/Color.svg";
import icon_Scenario from "../../../assets/svgs/MG/Escenarios.svg";
import icon_Seat from "../../../assets/svgs/MG/Seat.svg";
import icon_Gallery from "../../../assets/svgs/MG/Galería.svg";

interface Props {
  isInternalView: boolean;
  menu: string;
  setMenu: (value: string) => void;
}

const BottombarMain: React.FC<Props> = ({ isInternalView, menu, setMenu}) => {
  
  return (
      <div className={`bottombar-main-container`}>
        <div className={`bottombar-main-container-scroll`}>
          <div className={`bottombar-main-button ${menu === 'Main' ? 'selected':''}`} onClick={() => setMenu('Main')}>
            <img className={`bottombar-main-button-logo`} src={icon_Main} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Vehículo</div>
          </div>
          <div className={`bottombar-main-button ${menu === 'Scenario' ? 'selected':''}`} onClick={() => setMenu('Scenario')}>
            <img className={`bottombar-main-button-logo`} src={icon_Scenario} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Escenarios</div>
          </div>
          {isInternalView === false && <div className={`bottombar-main-button ${menu === 'Color' ? 'selected':''}`} onClick={() => setMenu('Color')}>
            <img className={`bottombar-main-button-logo`} src={icon_Color} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Color</div>
          </div>}
          {isInternalView === true && <div className={`bottombar-main-button ${menu === 'Seat' ? 'selected':''}`} onClick={() => setMenu('Seat')}>
            <img className={`bottombar-main-button-logo`} src={icon_Seat} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Asientos</div>
          </div>}
          <div className={`bottombar-main-button ${menu === 'Options' ? 'selected':''}`} onClick={() => setMenu('Options')}>
            <img className={`bottombar-main-button-logo`} src={icon_Gallery} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Galería</div>
          </div>
        </div>
      </div>
  );
};

export default BottombarMain;